import { Box, Button, Stack, Typography } from '@mui/material';
import tempProductImg from "../../images/temp_atpl_product_img.png";
import AtplPrimaryBt from '../../components/ATPlab/AtplPrimaryBtn/AtplPrimaryBt';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useClientApi } from '../../api/client';

const AtplProdReccomendationPopUp = ({ closePopup }) => {
    const navigate = useNavigate();
    const clientApi = useClientApi("ATP");
    const [orgProductsList, setOrgProductsList] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);



    // Fetch organization products once
    useEffect(() => {
        const fetchTopProducts = async () => {
            const sessionId = localStorage.getItem('session-id');
            if (!sessionId) {
                setError('Session ID missing');
                setLoading(false);
                return;
            }
            try {
                setLoading(true); 
                const response = await clientApi.getProductRecommendations(sessionId);

                // Only process if the response is successful
                if (response.status === 200 && response.data) {
                    let products = [];
                    const seenProductIds = new Set();  // Set to track seen product IDs

                    // If 'symptoms' category exists, use it
                    if (response.data.symptoms) {
                        products = response.data.symptoms;
                    }

                    // If no products found, look into other categories
                    if (products.length === 0) {
                        // Include products from all available categories
                        const fallbackCategories = Object.keys(response.data).filter(key => key !== 'symptoms');
                        fallbackCategories.forEach(category => {
                            if (response.data[category]) {
                                products = products.concat(response.data[category]);
                            }
                        });
                    }
    
                    // Remove duplicates by ensuring each product is added only once based on its product_id
                    const uniqueProducts = [];
                    products.forEach(product => {
                        if (product.product_id && !seenProductIds.has(product.product_id)) {
                            uniqueProducts.push(product);
                            seenProductIds.add(product.product_id); // Track the product ID
                        }
                    });
    
                    // simply slice the first 3 products
                    const topProducts = uniqueProducts.slice(0, 3);  // Take top 3 unique products
    
                    // Format the top 3 products
                    const formattedTopProducts = topProducts.map(product => ({
                        id: product.product_id || Math.random(),  // Use product ID if available, else generate a random ID
                        name: product.product_name,
                        description: product.product_description,
                        restrictions: product.product_restrictions,
                        amazonAffiliateLink: product.product_link,
                        productImageAddress: product.product_image_address,
                        brand: product.product_brand,
                        reason: product.reason,
                        vitalName: product.vital_name || null,
                        vitalValue: product.vital_value || null,
                        brandImageAddress: product.brand_image_address,
                    }));
    
                    setOrgProductsList(formattedTopProducts);  // Set the top 3 unique products in state
                    setError(null);  // Clear any errors
                } else {
                    setError('No products found');
                }
            } catch (error) {
                console.error('Error fetching top products:', error);
                setError('Error fetching products');
            } finally {
                setLoading(false);  // End loading
            }
        };
        fetchTopProducts();
    }, []);


    const onViewResultBtnClick = () => {
        closePopup()
    }


    // handle affiliate reditection on product name or img click
    const handleRedirect = (link) => {
        // Redirect to the Amazon link in a new tab
        window.open(link, '_blank');

    }

    return (
        <Box className="atpl-intro-wrapper"
        >
            <Box sx={{
                boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)', // Box shadow
                backgroundColor: "#FFF"
                
            }}>
                <Stack>
                    <Typography fontSize="25px" fontWeight="700" color="#545454" textAlign="center" marginTop="20px"
                        lineHeight="30px" marginBottom="10px">Based on your results we recommend</Typography>
                </Stack>
                <Stack>
                    {orgProductsList.length ?
                        orgProductsList.slice(0, 3).map((data, index) => (
                            <Box key={index}
                                onClick={() => handleRedirect(data?.amazonAffiliateLink)}
                                sx={{
                                    minHeight: '136px',
                                    // width: '300px',
                                    padding: '2px',
                                    boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.1),0px 4px 23px rgba(0, 0, 0, 0.04)',
                                    // boxShadow: [
                                    //     '0px 9px 20px 0px rgba(0, 0, 0, 0.1)',
                                    //     '0px 37px 37px 0px rgba(0, 0, 0, 0.09)',
                                    //     '0px 83px 50px 0px rgba(0, 0, 0, 0.05)',
                                    //     '0px 147px 59px 0px rgba(0, 0, 0, 0.01)',
                                    //     '0px 230px 64px 0px rgba(0, 0, 0, 0)',
                                    // ].join(', '),

                                    borderRadius: '15px',
                                    padding: "14px 16px",
                                    cursor : "pointer",
                                    marginBottom: index != 2 ? "24px" : "0px"

                                }}
                            >
                                <Stack display="flex" flexDirection="row" justifyContent="space-between" gap={1}>
                                    <Stack flex="6">
                                        <Typography
                                            // onClick={() => handleRedirect(data?.amazonAffiliateLink)}
                                            sx={{
                                                fontSize: '16px',
                                                cursor: 'pointer',
                                                fontWeight: 600,
                                                color: '#000000',
                                                display: '-webkit-box',
                                                WebkitBoxOrient: 'vertical',
                                                overflow: 'hidden',
                                                WebkitLineClamp: 3,
                                            }} >{data?.name}
                                        </Typography>
                                        <Typography
                                            sx={{
                                                fontSize: '12px',
                                                fontWeight: 500,
                                                color: '#000000',
                                                display: '-webkit-box',
                                                WebkitBoxOrient: 'vertical',
                                                overflow: 'hidden',
                                                WebkitLineClamp: 4, // Limit to 3 lines
                                            }}
                                        >
                                            {data.reason}
                                        </Typography>
                                        {/* <Button sx={{
                                        width: "109px",
                                        backgroundColor: " #000000A6",
                                        color: "white",
                                        height: "33px",
                                        marginTop: "20px",
                                        '&:hover': {
                                            backgroundColor: "#000000A6", // Make hover state the same as normal state

                                        }

                                    }} >Add To Cart</Button> */}
                                    </Stack>
                                    <Stack display="flex" justifyContent="center" alignItems="center" flex="3">
                                        <Box onClick={() => handleRedirect(data?.amazonAffiliateLink)} sx={{ cursor: "pointer" }}>
                                            <img src={data.productImageAddress} style={{ width: "83px", height: "auto" }}></img>

                                        </Box>
                                        {/* <Typography textAlign="center" fontSize="12px" fontWeight="600" color="#F15C30" paddingTop="8px">See Predicted Health Effects</Typography> */}
                                    </Stack>

                                </Stack>

                            </Box>

                        ))

                        :
                        <Box sx={{ height: "150px", textAlign: "center", padding: "20px 0px" }}>
                            <Typography> No Product Data Found </Typography>

                        </Box>
                    }

                </Stack>
                <Stack sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    padding: "20px 2px",
                    justifyContent: "center",



                }} >
                    <Typography

                        sx={{
                            textAlign: "center",
                            fontSize: "15px",
                            fontWeight: "500",
                            color: "#F15C30",
                            cursor: "pointer"
                        }}
                        onClick={onViewResultBtnClick}>View the full results of my health scan</Typography>

                    <ArrowForwardIcon sx={{ color: "#F15C30", paddingLeft: "10px", cursor: "pointer" }}></ArrowForwardIcon>
                </Stack>
            </Box>
        </Box>
    )
}

export default AtplProdReccomendationPopUp;